// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import i18n from './language'
import { store } from '@/store'

import {
  getCookie
} from './commonFunction/commonFunction';


Vue.config.productionTip = false;

Vue.mixin({

  data: function () {
    return {
      img_homeMonster : '@/assets/images/homePage/homeMonster.png',

      generalAudioList : [
        "general/hold",
        "general/swipe",
        "general/click",
        "general/patternCorrectCode",
        "general/patternWrongCode",
        "general/patternPopV1",
        "general/patternPopV2",
        "general/patternPopV3",
        "general/patternPopV4",
        "general/logoClick",
      ],

      websiteAudioList : [
        "home/music",
      ],

      comic1AudioList : [
        "chapter1LandingMusic",
        "chapter1LandingClickMe",
        "chapter1LandingBubblePopV1",
        "chapter1LandingBubblePopV2",
        "chapter1LandingBubblePopV3",
        "chapter1LandingBubblePopV4",
        "chapter1LandingWrongCode",
        "chapter1LandingCorrectCode",
        "chapter1LandingCreatureBorn",
        "chapter1LandingCreatureClickMe",
        "chapter1ComicBgm1",
        "chapter1ComicBgm2",
        "chapter1ComicEyeBlink",
        "chapter1ComicZoomOut",
        "chapter1ComicSpringLaunch",
        "chapter1ComicLaunch2",
        "chapter1ComicExplosion",
        "chapter1ComicBubblePop",
        "chapter1ComicFallOnGround",
        "chapter1ComicBiospheresReveal",
        "chapter1ComicEnemyReveal",
        "chapter1ComicEnemyDashIn",
        "chapter1ComicSpiderSense",
        "chapter1ComicEnemyAttack1",
        "chapter1ComicDodge",
        "chapter1ComicMiss1",
        "chapter1ComicEnemyAttack2",
        "chapter1ComicMiss2",
        "chapter1ComicEscape",
        "chapter1ComicChase",
        "chapter1ComicEnemyHitRock",
        "chapter1ComicEnemyHitDash",
        "chapter1ComicFight2Miss",
        "chapter1ComicFight2Dodge",
        "chapter1ComicFight2EnemyDashOut",
        "chapter1ComicFight2Attack",
        "chapter1ComicFight2Impact",
        "chapter1ComicFight2Defeat",
        "chapter1ComicRockFall",
        "chapter1ComicMonsterReveal",
        "chapter1ComicMonsterReveal2",
        "chapter1ComicMonsterRoar",
        "chapter1ComicLast",
        "chapter1ComicLogoClick",
      ],

      homepageAudioList : [
        "chapter1HomeMusic",
        "chapter1HomePoke",
        "chapter1HomeScream",
        "chapter1HomeBlink",
        "chapter1HomeSubmit",
        "chapter1HomeRockMove",
        "chapter1HomeMonsterRoar",
      ],

      comic2AudioList : [
        "chapter2/sound1",
        "chapter2/bgm1",
        "chapter2/swoosh1",
        "chapter2/kramGasp",
        "chapter2/swoosh2",
        "chapter2/sedSound",
        "chapter1ComicMonsterReveal",
        "chapter1ComicMonsterReveal2",
        "chapter1ComicMonsterRoar",
        "chapter1HomeScream",
        "chapter2/swoosh3",
        "chapter2/bgm2",
        "chapter2/swoosh4",
        "chapter2/nunijProjectile",
        "chapter2/nunijImpact",
        "chapter2/nunijReadyAttack",
        "chapter2/nunijAttack",
        "chapter2/wind1",
        "chapter2/nunijXBlomph",
        "chapter2/nunijCharge",
        "chapter2/wind2",
        "chapter2/blomphReflect",
        "chapter2/wind0",
        "chapter2/blomphBite",
        "chapter2/blomphGulp",
        "chapter2/blomphRoar2",
        "chapter2/windGust",
        "chapter2/groundSfx",
        "chapter2/blomphAttack",
        "chapter2/sedDash",
        "chapter2/sedDash2",
        "chapter2/blomphBite2",
        "chapter2/windGust2",
        "chapter1ComicFight2Attack",
        "chapter2/blomphPain",
        "chapter2/sedAttackImpact",
        "chapter2/blomphGrowl",
        "chapter2/sedGasp",
        "chapter2/sedDash3",
        "chapter2/blomphProjectile",
        "chapter2/sedDash4",
        "chapter2/sedSecondHit",
        "chapter2/sedSecondImpact",
        "chapter2/blomphPain2",
        "chapter2/crash",
        "chapter2/bgm3",
        "chapter2/rockFalling",
        "chapter2/eignaFirstAttackGlow",
        "chapter2/eignaAttack",
        "chapter2/bgm4",
        "chapter2/eignaAttack2",
        "chapter2/kramSurprised",
        "chapter2/blomphPain3",
        "chapter2/blomphRoar3",
        "chapter2/eignaXBlomph",
        "chapter2/kramScream2",
        "chapter2/blomphProjectile2",
        "chapter2/fire",
        "chapter2/fire2",
        "chapter2/bgm5",
        "chapter2/fire3",
        "chapter2/kramWow",
        "chapter2/kramBounce",
        "chapter2/kramBlinkOnce",
        "chapter2/kramHuh",
        "chapter2/sedSigh",
        "chapter2/sedHa",
        "chapter2/sedGlow",
        "chapter2/sedDisappear",
        "chapter2/primeSfx",
        "chapter2/evolveSfx",
        "chapter2/evolveReveal",
      ],

      comic3AudioList : [
        "chapter3/bgm1",
        "chapter3/bgm2",
        "chapter3/bgm3",
        "chapter3/presence",
        "chapter3/kramFly",
        "chapter3/distantBlomphRoar",
        "chapter3/explosion",
        "chapter3/kramFly2",
        "chapter3/pushBack",
        "chapter3/blomphProjectile",
        "chapter3/blomphProjectileClone",
        "chapter3/swoosh1",
        "chapter3/swoosh2",
        "chapter3/swoosh3",
        "chapter3/swoosh4",
        "chapter3/blomphSound",
        "chapter3/monsterReveal",
        "chapter3/monsterReveal2",
        "chapter3/crash",
        "chapter3/blomphGrowl",
        "chapter3/energyCharge",
        "chapter3/eignaCharge",
        "chapter3/blomphHit",
        "chapter3/eignaAttack",
        "chapter3/explosion3",
        "chapter3/crackling2",
        "chapter3/blomphMDie",

        "chapter3/blomphCharge",

        
        "chapter3/kramGasp",

        "chapter3/smallProjectile",
        "chapter3/smallProjectile2",

        "chapter3/bgmSFX",
        "chapter3/kramDodge",


        "chapter3/eignaAttackImpact",
        "chapter3/eignaAttackImpactExplosion",

        "chapter3/kramScream",

        "chapter3/ambient",

        "chapter3/monsterGrowl1",
        "chapter3/monsterGrowl2",

        "chapter3/bannerBlomphGrowl",

        "chapter3/patternOverlay",

        "chapter3/eignaAttack2",

        "chapter3/eignaAttackB",

        "chapter3/windGust",

        "chapter3/blomphProjectile2",

        "chapter3/kramExplosion",

        "chapter3/kramDash",

        "chapter3/kramExplosion2",

        "chapter3/kramAttack",

        "chapter3/blomphMExplosion",

        "chapter3/blomphProjectile3",

        "chapter3/kramFly3",
        "chapter3/kramSkyFly2",

        "chapter3/kramFlyDown",
        "chapter3/kramFlyDownExplosion",
        "chapter3/kramFlyDownEffect",

        "chapter3/kramSonicBoomCharge",

        "chapter3/kramCrashBlomph",
        "chapter3/blomphPain",

        "chapter3/blomphMDie2",

        "chapter3/eignaFinalAttack",
        "chapter3/eignaFinalAttackExplosion1",
        "chapter3/eignaFinalAttackExplosion2",

        "chapter3/primeFalling",
        "chapter3/energyExplosion",

        "chapter3/kramKick",

      ],
    }
  },

  methods: {

    initFirebase(){

      if(store.state.firebaseApp == null){
        let self = this;
        const firebaseConfig = {
          apiKey: "AIzaSyAr9TXScf2eqGcnJewnS9mJSQ3HneYaxxU",
          authDomain: "biospheres-feb82.firebaseapp.com",
          projectId: "biospheres-feb82",
          storageBucket: "biospheres-feb82.appspot.com",
          messagingSenderId: "131809594919",
          appId: "1:131809594919:web:d2d0175587e30b65aa8802",
          measurementId: "G-SXT80GWPPF"
        };
  
        store.state.firebaseApp = firebase.initializeApp(firebaseConfig);
        store.state.firebaseAuth = firebase.auth();
        store.state.firebaseDb = firebase.firestore();
        
        store.state.firebaseAuth.setPersistence(firebase.auth.Auth.Persistence.LOCAL)
        .then(() => {
          if(store.state.firebaseAuth.currentUser != null){
            if(store.state.firebaseAuth.currentUser.emailVerified){
              store.state.account = store.state.firebaseAuth.currentUser;
              this.checkAccountDiscordId();
            }
            else{
              store.state.firebaseAuth.signOut()
              .then(function(){
              })
              .catch(function(error){
              });
            }
          }
          store.state.isFirebaseLoaded = true;
        })
        .catch((error) => {
          // Handle Errors here.
          const errorCode = error.code;
          const errorMessage = error.message;
        });
      }
      
    },

    async checkAccountDiscordId(){
      let self = this;
      if(store.state.firebaseDb != null && store.state.account.uid != null){
        const fragment = (new URLSearchParams(window.location.hash));
        const accessToken = fragment.get('access_token');
        let isCancelLogin = false;
        let tokenType = null;
        if(window.location.href.includes("token_type=")){
          let tokenTypeData1 = window.location.href.split("token_type=")[1];
          tokenType = tokenTypeData1.split("&")[0];
        }
        if(window.location.href.includes("error=access_denied")){
          isCancelLogin = true;
        }


        if (accessToken != null && tokenType != null) {
          fetch('https://discord.com/api/users/@me', {
            headers: {
                authorization: `${tokenType} ${accessToken}`,
            },
          })
          .then(result => result.json())
          .then(response => {
              const {id} = response;
              let discordData = {
                  id : id,
              }
              if(discordData.id != null){
                self.updateDiscordId(discordData.id);
              }
          })
          .catch(error => {
            console.log(error);
          });
          var newURL = location.href.split("token_type")[0];
          window.history.pushState('object', document.title, newURL);
          self.directToAccount();
        }
        else if(isCancelLogin){
          self.directToAccount();
        }
        else{
          this.checkAccountDiscordIdAfterLogin();
          this.checkAccountWalletAddressAfterLogin();
        }
      }
    },

    async checkAccountDiscordIdAfterLogin(){
      var docRef = store.state.firebaseDb.collection("users").doc(store.state.firebaseAuth.currentUser.uid);
      docRef.get().then((doc) => {
          if (doc.exists && doc.data() != null && doc.data().discordId != null) {
            store.state.discordId =  doc.data().discordId;
          } 
      })
      // let checkDiscordIdRequest = await getDoc(doc(store.state.firebaseDb, "users", store.state.account.uid));
      // if(checkDiscordIdRequest.data() != null && checkDiscordIdRequest.data().discordId != null){
      //   store.state.discordId = checkDiscordIdRequest.data().discordId;
      // }
    },

    async checkAccountWalletAddressAfterLogin(){

      // let checkWalletAddressRequest = await getDoc(doc(store.state.firebaseDb, "users", store.state.account.uid));
      // if(checkWalletAddressRequest.data() != null && checkWalletAddressRequest.data().walletAddress != null){
      //   store.state.walletAddress = checkWalletAddressRequest.data().walletAddress;
      // }

    },

    async updateDiscordId(_discordId){
      const q = store.state.firebaseDb.collection("users").where("discordId", "==", _discordId).get()
      .then((querySnapshot) => {
          if(querySnapshot.docs.length == 0){
            store.state.discordId = _discordId;
            var query = store.state.firebaseDb.collection('users').doc(store.state.firebaseAuth.currentUser.uid).set({
                discordId: _discordId
            }, { merge: true });
            
          }
          else{
            store.state.accountErrorMessageText = i18n.t('accountErrorMessage')['discordAccountInUse'];
          }
      })
      .catch((error) => {
      });

    },

    preloadWebsiteAudioBuffer(){
      let self = this;
      let audioLists = this.generalAudioList.concat(this.websiteAudioList);
      audioLists.forEach( async (audioId , index) => {
        if(!store.state.audioBuffer[audioId]){
          const buffer = await this.getAudioBuffer("static/audio/" + audioId + ".mp3");
          store.state.audioBuffer[audioId] = buffer;
        }
      });
    },

    preloadGeneralAudioBuffer(){
      let self = this;
      let audioLists = this.generalAudioList;
      audioLists.forEach( async (audioId , index) => {
        if(!store.state.audioBuffer[audioId]){
          const buffer = await this.getAudioBuffer("static/audio/" + audioId + ".mp3");
          store.state.audioBuffer[audioId] = buffer;
        }
      });
    },

    preloadChapter1AudioBuffer(){
      let self = this;
      let audioLists = this.generalAudioList.concat(this.comic1AudioList).concat(this.homepageAudioList);
      audioLists.forEach( async (audioId , index) => {
        if(!store.state.audioBuffer[audioId]){
          const buffer = await this.getAudioBuffer("static/audio/" + audioId + ".mp3");
          //save buffer
          store.state.audioBuffer[audioId] = buffer;
        }
      });
    },

    preloadChapter2AudioBuffer(){
      let audioLists =  this.generalAudioList.concat(this.comic2AudioList).concat(this.homepageAudioList);
      audioLists.forEach( async (audioId , index) => {
        if(!store.state.audioBuffer[audioId]){
          const buffer = await this.getAudioBuffer("static/audio/" + audioId + ".mp3");
          //save buffer
          store.state.audioBuffer[audioId] = buffer;
        }
      });
    },

    preloadChapter3AudioBuffer(){
      let audioLists =  this.generalAudioList.concat(this.comic3AudioList).concat(this.homepageAudioList);
      audioLists.forEach( async (audioId , index) => {
        if(!store.state.audioBuffer[audioId]){
          const buffer = await this.getAudioBuffer("static/audio/" + audioId + ".mp3");
          //save buffer
          store.state.audioBuffer[audioId] = buffer;
        }
      });
    },

    stopAudio(audioId){
      if(store.state.audioSource[audioId] != null){
        store.state.audioSource[audioId].stop();
      }
    },

    stopAllAudio(mute = false){
      let audioLists = this.websiteAudioList.concat(this.generalAudioList).concat(this.comic1AudioList).concat(this.comic2AudioList).concat(this.comic3AudioList);
      audioLists.forEach(audioId => {
        if(store.state.audioSource[audioId] != null){
          store.state.audioSource[audioId].stop();
        }
      });
      store.state.playingAudio = "";

      if(mute){
        store.state.manualStoppedMusic = true;
      }
    },

    stopAllComic2Audio(mute = false){
      let audioLists =  this.generalAudioList.concat(this.comic2AudioList);
      audioLists.forEach(audioId => {
        if(store.state.audioSource[audioId] != null){
          store.state.audioSource[audioId].stop();
        }
      });
      store.state.playingAudio = "";
      if(mute){
        store.state.manualStoppedMusic = true;
      }
    },

    stopAllComic3Audio(mute = false){
      let audioLists =  this.generalAudioList.concat(this.comic3AudioList);
      audioLists.forEach(audioId => {
        if(store.state.audioSource[audioId] != null){
          store.state.audioSource[audioId].stop();
        }
      });
      store.state.playingAudio = "";
      if(mute){
        store.state.manualStoppedMusic = true;
      }
    },

    async playAudio(audioId , isLoop = false, mode = "separate"){
      if(!store.state.audioContext){
        store.state.audioContext = new AudioContext();
      }
      
      //need stop previous single first?
      if(mode == "single"){
        if(store.state.playingAudio != ""){
          if(store.state.audioSource[store.state.playingAudio] != null){
            store.state.audioSource[store.state.playingAudio].stop();
            store.state.playingAudio = "";
          }
        }
      }
      else{
        if(store.state.audioSource[audioId] != null){
          store.state.audioSource[audioId].stop();
        }
      }

      if(!store.state.manualStoppedMusic){
        const source = store.state.audioContext.createBufferSource();
        if(!store.state.audioBuffer[audioId]){
          const buffer = await this.getAudioBuffer("static/audio/" + audioId + ".mp3");
          //save buffer
          store.state.audioBuffer[audioId] = buffer;
          source.buffer = buffer;
        }
        else{
          source.buffer = store.state.audioBuffer[audioId];
        }

        // var gainNode = store.state.audioContext.createGain()
        // gainNode.gain.value = 0.2 // 10 %
        // gainNode.connect(store.state.audioContext.destination)

        // source.connect(gainNode);


        source.connect(store.state.audioContext.destination);
        source.loop = isLoop;
        source.start();
        store.state.audioSource[audioId] = source;
        if(mode == "single"){
          store.state.playingAudio = audioId;

        }
        store.state.manualStoppedMusic = false;
      }


      
    },
    
    getAudioBuffer(url){
      if(!store.state.audioContext){
        store.state.audioContext = new AudioContext();
      }
      const request = new XMLHttpRequest();
      return new Promise((resolve, reject) => {
        request.open('GET', url, true);
        request.responseType = 'arraybuffer';
        request.onload = () => {
          store.state.audioContext.decodeAudioData(request.response, buffer => buffer ? resolve(buffer) : reject('decoding error'));
        };
        request.onerror = error => reject(error);
        request.send();
      });
    },

    temporaryDisableTouchWhenScroll(element){
      if(element.classList.contains("touch")){
        element.classList.remove("touch");
        setTimeout(() => {
          element.classList.add("touch");
        }, 500);
      }
    },

    directToComic(isPlaySound){
      if(this.$route.path != "/comic"){
        if(isPlaySound){
          this.playAudio("general/click",false,"separate");
        }
        this.$router.push('/comic');
      }    
    },
    directToLeaderboard(isPlaySound){
      if(this.$route.path != "/leaderboard"){
        if(isPlaySound){
          this.playAudio("general/click",false,"separate");
        }
        this.$router.push('/leaderboard');
      }      
    },
    directToKwodex(isPlaySound){
      if(this.$route.path != "/kwodex"){
        if(isPlaySound){
          this.playAudio("general/click",false,"separate");
        }
        this.$router.push('/kwodex');
      }      
    },
    directToFaq(isPlaySound){
      if(this.$route.path != "/faq"){
        if(isPlaySound){
          this.playAudio("general/click",false,"separate");
        }
        this.$router.push('/faq');
      }
    },
    directToAccount(isPlaySound){
      if(this.$route.path != "/account"){
        if(isPlaySound){
          this.playAudio("general/click",false,"separate");
        }
        this.$router.push('/account');
      }
    },
    directToHome(isPlaySound){
      if(this.$route.path != "/home" && this.$route.path != "/" && this.$route.path != ""){
        if(isPlaySound){
          this.playAudio("general/click",false,"separate");
        }
        this.$router.push('/');
      }
    },
    directToComic1(isPlaySound){
      if(this.$route.path != "/comic/chapter1"){
        if(isPlaySound){
          this.playAudio("general/click",false,"separate");
        }
        this.$router.push('/comic/chapter1');
      }
    },
    directToComic2(isPlaySound){
      if(this.$route.path != "/comic/chapter2"){
        if(isPlaySound){
          this.playAudio("general/click",false,"separate");
        }
        this.$router.push('/comic/chapter2');
      }
    },
    directToComic3(isPlaySound){
      if(this.$route.path != "/comic/chapter3"){
        if(isPlaySound){
          this.playAudio("general/click",false,"separate");
        }
        this.$router.push('/comic/chapter3');
      }
    },


    directLink(platform){
      this.playAudio("general/click",false,"separate");
      if(platform == "instagram"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to Instagram', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("https://www.instagram.com/playbiospheres/", '_blank').focus();
      }
      else if(platform == "twitter"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to Twitter', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("https://twitter.com/playbiospheres", '_blank').focus();
      }
      else if(platform == "discord"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to Discord', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("https://discord.gg/HYGBYshN6v", '_blank').focus();
      }
      else if(platform == "collectiv"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to Collectiv', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("https://collectiv.co/", '_blank').focus();
      }
      else if(platform == "gamefi"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to Gamefi', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("https://gamefiventures.com/", '_blank').focus();
      }
      else if(platform == "blowfish"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to Blowfish', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("https://www.blowfishstudios.com/", '_blank').focus();
      }
      else if(platform == "crew3"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to crew3', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("https://crew3.xyz/c/biospheres/questboard/", '_blank').focus();
      }
      else if(platform == "privacyPolicy"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to Privacy Policy', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("/#/privacyPolicy", '_blank').focus();
      }
      else if(platform == "termOfUse"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to Term Of Use', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("/#/termOfUse", '_blank').focus();
      }
      else if(platform == "cookiePolicy"){
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Direct to Cookie Policy', {'event_category' : 'general','event_callback': function() {}});
        }
        window.open("/#/cookiePolicy", '_blank').focus();
      }
    },

    getReferrer(){
      if(document.referrer){
        let referrerUrl = document.referrer;
        if(referrerUrl.startsWith("http://") || referrerUrl.startsWith("https://")){
          let domain = (new URL(referrerUrl));
          domain = domain.hostname;
          if(store.state.isUserAcceptedCookies){
            gtag('event', 'Referrer : ' + domain, {'event_category' : 'general','event_callback': function() {}});
          }
        }
        else{
          if(store.state.isUserAcceptedCookies){
            gtag('event', 'Referrer : ' + document.referrer, {'event_category' : 'general','event_callback': function() {}});
          }
        }
      }
      else{
        if(store.state.isUserAcceptedCookies){
          gtag('event', 'Referrer : direct', {'event_category' : 'general','event_callback': function() {}});
        }
      }
    },

    getLatestChapter1CollectedPrime(){
      if(store.state.isUserAcceptedCookies){
        let chapter1CollectedPrimeCookies = getCookie("chapter1CollectedPrime");
        if(chapter1CollectedPrimeCookies){
          if(chapter1CollectedPrimeCookies.includes("28f249a988bc22d4974861276da8554d")){
            store.state.chapter1CollectedPrime['E'] = true;
          }
          if(chapter1CollectedPrimeCookies.includes("70295e9587e5121d7711da434f17fb96")){
            store.state.chapter1CollectedPrime['K'] = true;
          }
          if(chapter1CollectedPrimeCookies.includes("5cae89f1c995d527bc63b2129af4dde3")){
            store.state.chapter1CollectedPrime['P'] = true;
          }
          if(chapter1CollectedPrimeCookies.includes("fcac1aeac211f778e8ae3d4217f279a0")){
            store.state.chapter1CollectedPrime['R'] = true;
          }
          if(chapter1CollectedPrimeCookies.includes("849e3cb171581c867249889179afcd21")){
            store.state.chapter1CollectedPrime['W'] = true;
          }
        }

        
      }
      return store.state.chapter1CollectedPrime;
    },

    checkCookies(){
      let unlockProgressCookie = this.getCookie("unlockProgress");
      if(!unlockProgressCookie){
        this.deleteAllCookies();
        if(!store.state.isUserAcceptedCookiesAnswered){
          store.state.isShowCookiesAcceptanceMessage = true;
        }
      }
      else{
        store.state.isUserAcceptedCookies = true;
        if(!store.state.isGAEnabled){
          enableGA();
          store.state.isGAEnabled = true;
        }
      }
    },

    checkIsInteger(number){
      return Number.isInteger(number);
    },
    randomInt(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    getElement(id){ 
      return document.getElementById(id);
    },
    getPositionAtCenter(element) {
      const {top, left, width, height} = element.getBoundingClientRect();
      return {
        x: left + width / 2,
        y: top + height / 2
      };
    },
    getDistanceBetweenElements(a, b) {
      const aPosition = this.getPositionAtCenter(a);
      const bPosition = this.getPositionAtCenter(b);
      return Math.sqrt(
        Math.pow(aPosition.x - bPosition.x, 2) + 
        Math.pow(aPosition.y - bPosition.y, 2) 
      );
    },
    getCookie(cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    },
    deleteAllCookies() {
      var cookies = document.cookie.split(";");
      for (var i = 0; i < cookies.length; i++) {
          var cookie = cookies[i];
          var eqPos = cookie.indexOf("=");
          var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
          document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
      }
    },
    cmp(x, y){
      return x > y ? 1 : x < y ? -1 : 0; 
    },
    validateEmail(email) {
      return String(email)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
    },

    validate_email(email) {
      const expression = /^[^@]+@\w+(\.\w+)+\w$/
      return (expression.test(email) == true);
    },

    validate_password(password) {
      return (password.length >= 6);
    },

    mobileChecking(){
      if (typeof window.orientation == 'undefined') {
        store.state.isMobile = false;
      }
      else{
        store.state.isMobile = true;
      }
    },
    squareCalculation(){
      for(let processingSquare = 100; processingSquare > 0 ; processingSquare --){
        let squareElements = document.getElementsByClassName('square' + processingSquare);
        for(let elementLoop = 0; elementLoop < squareElements.length ; elementLoop ++){
          squareElements[elementLoop].style.height = window.innerHeight * (processingSquare / 100) + "px";
          squareElements[elementLoop].style.width = window.innerHeight * (processingSquare / 100) + "px";
        }
      }
    },
    unityCanvasCalculation(){
      let canvas = this.getElement("unity-canvas");
      if(canvas != null){
        if( window.innerWidth / window.innerHeight > (1920 / 1080) ){
          canvas.style.height = window.innerHeight + "px";
          canvas.style.width = window.innerHeight * (1920 / 1080) + "px";
        }
        else{
          canvas.style.width = window.innerWidth + "px";
          canvas.style.height = window.innerWidth * (1080 / 1920) + "px";
        }
      }
    },
    calculateProcessingPercentage(value, start, end){
      if(start < end){
        let thisProcessingPercentage = (value - start) / (end - start);
        return thisProcessingPercentage;
      }
      else{
        let thisProcessingPercentage = (value - end) / (start - end);
        return thisProcessingPercentage + 1;
      }
    }
  },
})

import '@/style.css';
import '@/styles/comic.css';

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  components: { App },
  template: '<App/>'
})






// WEBPACK FOOTER //
// ./src/main.js